export const PREFIX_EXT_TERMS = 'website_'
